mutation deleteReservedOa($id: ID!) {
  deleteReservedOa(id: $id)
}
